export const environment = {
  logAppId: '',
  version: '0.0.48',
  production: false,
  apiUrl: "https://adapi-stag.ascent24.io/",
  loggerUrl: "",
  paymentRedirectUrl: "",
  // orgId: "5408d9ae-df08-11eb-90b5-778bb5378171",
};
